import { RoutePageType } from "@routes/interfaces"
import VeiculoLista from "./pages/VeiculoLista"
import VeiculoCriar from "./pages/VeiculoCriar"

const veiculoPages: RoutePageType[] = [
    {key: 'cadastroVeiculoLista', element: VeiculoLista},
    {key: 'cadastroVeiculoCriar', element: VeiculoCriar},
]

export default veiculoPages